import {Stack, styled} from "@mui/material";


export const CenteredStack = styled(Stack)(({ theme }) => ({height: "100%",justifyContent: "space-evenly",alignItems: "center",display: "flex"}));